import type { LanternV2Recipe } from './lantern';

/** The hung clue lantern outside: salt-worn, lit, repaired. */
export const HUSH_LANTERN_V2_HANGING: LanternV2Recipe = {
  schema: 'hush.asset-recipe.v1',
  id: 'hush.lantern.v2.hanging.salt_worn',
  generatorId: 'hush.lantern.v2',
  seed: 20067018,
  paletteId: 'coastal_salt',
  params: { support: 'hanging', condition: 'salt_worn', warmth: 0.8, repairPatch: true },
};

/** Mallow's hearth lantern inside the Nook: standing, warm paper, fully lit. */
export const HUSH_LANTERN_V2_STANDING: LanternV2Recipe = {
  schema: 'hush.asset-recipe.v1',
  id: 'hush.lantern.v2.standing.interior_warm',
  generatorId: 'hush.lantern.v2',
  seed: 20067018,
  paletteId: 'nook_warm',
  params: { support: 'standing', condition: 'interior_warm', warmth: 0.95, repairPatch: true },
};
